import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { PickupAddress } from '../constants';
const DeliveryCharges = ({ orderDetails, selectedAddress, onChargeUpdate, selectedAddressId }) => {
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const { items } = useSelector((state) => state.cart);
  const { addressList } = useSelector((state) => state.address);
  const [lastCalculatedSubtotal, setLastCalculatedSubtotal] = useState(null);
  const [lastSelectedAddress, setLastSelectedAddress] = useState(null);

  // console.log(selectedAddress, "selectedAddress in delivery charges");
  useEffect(() => {
    const calculateDeliveryCharges = async () => {
      // Get the selected address either from prop or from addressList
      const addressToUse = selectedAddress || addressList.find(addr => addr._id === selectedAddressId);

      if (!addressToUse?.postalCode || !orderDetails?.summary?.subtotal) {
        setIsLoading(false);
        return;
      }

      // Skip if we've already calculated for this subtotal AND the address hasn't changed
      if (lastCalculatedSubtotal === orderDetails.summary.subtotal && 
          selectedAddressId && 
          lastSelectedAddress === selectedAddressId) {
        return;
      }

      // Only calculate if subtotal is less than 800
      if (parseFloat(orderDetails.summary.subtotal) >= 800) {
        setDeliveryCharge(0);
        onChargeUpdate(0, true);
        setIsLoading(false);
        setLastCalculatedSubtotal(orderDetails.summary.subtotal);
        setLastSelectedAddress(selectedAddressId);
        return;
      }

      try {
        // Calculate total weight from cart items
        const totalWeightInGrams = items.reduce((total, item) => {
          // Handle both logged-in and guest user cart item structures
          const weightInGrams = item.weightId?.weightInGrams || // For logged-in users
                              item.weights?.find(w => w._id === item.weightId._id)?.weightInGrams || // For guest users
                              500; // Default weight if not found
          return total + (weightInGrams * item.quantity);
        }, 0);

        // Convert weight to KG
        const weightInKg = totalWeightInGrams / 1000;

        // Determine if COD is needed based on payment method from orderDetails

        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/shiprocket/calculate-charges`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              pickup_postcode: PickupAddress.postcode,
              delivery_postcode: addressToUse.postalCode,
              weight: weightInKg
            }),
          }
        );

        const data = await response.json();
        if (data.success && data.responseObject?.data?.available_courier_companies?.length > 0) {
          const recommendedCourier = data.responseObject.data.available_courier_companies[0];
          setDeliveryCharge(recommendedCourier.rate);
          onChargeUpdate(recommendedCourier.rate, true, recommendedCourier.courier_company_id);
        }
        setLastCalculatedSubtotal(orderDetails.summary.subtotal);
        setLastSelectedAddress(selectedAddressId);
      } catch (error) {
        console.error('Error calculating delivery charges:', error);
      } finally {
        setIsLoading(false);
      }
    };

    calculateDeliveryCharges();
  }, [selectedAddress, selectedAddressId, orderDetails?.summary?.subtotal, items, addressList]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-between mb-2">
        <span>Delivery Charges</span>
        <span>Calculating...</span>
      </div>
    );
  }

  if (!selectedAddress) {
    return (
      <div className="d-flex justify-content-between mb-2">
        <span>Delivery Charges</span>
        <span>Select an address</span>
      </div>
    );
  }
  if (deliveryCharge === 0) {
    return (
      <div className="d-flex justify-content-between mb-2">
        <span>Delivery Charges</span>
        <span className="text-success">Free Delivery</span>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-between mb-2">
      <span>Delivery Charges</span>
      <span>
        {deliveryCharge.toLocaleString('en-IN', {
          style: 'currency',
          currency: 'INR',
        })}
      </span>
    </div>
  );
};

export default DeliveryCharges; 